import React, {useEffect} from 'react';
import { useFormContext } from '../Provider';

const Hidden = ({name, value}) => {
    const { formData, updateField,  } = useFormContext();
    const formValue = formData[name] ?? null;

    useEffect(() => {
        if (!formValue !== value) {
            updateField(name, value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [name, formValue, value]);

    return <input type="hidden" name={name} value={formValue ?? ''} />
}

export default Hidden;
